module.exports = __webpack_public_path__ + "img/returned.568382f9.svg";